module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nextStepContainer"
  }, [_c('div', {
    class: {
      nextStep: true, notActive: !_vm.nextStepActive
    },
    on: {
      "click": _vm.goToNext
    }
  }, [_c('div', {
    staticClass: "button adapted black u-full-width",
    domProps: {
      "innerHTML": _vm._s(_vm.nextStepText)
    }
  })]), _vm._v(" "), (_vm.currentPicker != 'backgrounds') ? _c('div', {
    staticClass: "close button hide-for-mobile adapted",
    on: {
      "click": _vm.goToPrev
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('goBackToStep')) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "closePickers button adapted show-for-mobile",
    on: {
      "click": _vm.closePickers
    }
  }, [_c('i', {
    staticClass: "icon-close"
  }), _vm._v(" " + _vm._s(_vm.$t('close')) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bf73b3ea!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/NextStep.vue
// module id = 171
// module chunks = 0